import {InjectionToken} from '@angular/core';
import { Section } from '../../template-generator/entity/section';

export const SECTION_DATA = new InjectionToken<Section>('section data');
